import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import Modal from '../UI/Modal/Modal';
import Clickable from '../UI/Clickable/Clickable';
import { parseContentType } from '../../utils';
import classes from './ModalContent.module.css';

const ModalContent = ({ content, show, onCloseModal }) => {
  const { media } = content;
  const contentType = parseContentType(media ? media.mime : '');
  return (
    <Modal show={show} closeWithBackdrop={false}>
      <div className={classes.modalContent}>
        <Clickable onClick={onCloseModal}>
          <img
            src="/images/close-icon.svg"
            alt="close"
            className={classes.closeIcon}
          />
        </Clickable>
        {contentType === 'video' && (
          <ReactPlayer
            data-testid="modal-video"
            url={media.url}
            controls
            width="85%"
            height="85%"
          />
        )}
        {contentType === 'image' && (
          <img
            data-testid="modal-image"
            src={media.url}
            alt={content.title}
            className={classes.image}
          />
        )}
      </div>
    </Modal>
  );
};

ModalContent.propTypes = {
  content: PropTypes.shape({
    viewType: PropTypes.oneOf(['FILE', 'GENERAL']),
    thumbnail: PropTypes.shape({
      imageSrc: PropTypes.string,
    }),
    media: PropTypes.shape({ url: PropTypes.string, mime: PropTypes.string }),
    description: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    size: PropTypes.string,
    title: PropTypes.string,
    downloadable: PropTypes.bool,
  }),
  show: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

ModalContent.defaultProps = {
  content: {},
};

export default ModalContent;
